import 'client-only';

import { detectSigningFlowFromUrl } from './detect-signing-flow-from-url';
import { observeSigningFlow } from './observe-signing-flow.client';

/**
 * Inspect the current pageview URL + cookies and mark the active Sentry
 * scope as a signing-flow session when applicable. Called once at SDK init
 * from `instrumentation-client.ts`, before React hydrates.
 *
 * Never throws. Any error reading `window`/`document` or calling Sentry is
 * swallowed so observability can never interrupt page initialization.
 *
 * The cleanup returned by `observeSigningFlow()` is intentionally
 * discarded — at SDK init time the scope is owned by the pageview, and the
 * React hook's unmount-clear path handles SPA-navigation cleanup later.
 */
export function observeSigningFlowOnInit(): void {
  try {
    if (typeof window === 'undefined') return;

    const onSigningFlow = detectSigningFlowFromUrl({
      pathname: window.location.pathname,
      search: window.location.search,
      cookie: typeof document !== 'undefined' ? document.cookie : '',
    });

    if (!onSigningFlow) return;

    observeSigningFlow();
  } catch {
    // Observability must never interrupt page initialization.
  }
}
